import React, { useEffect } from 'react';
import useWindowDimensions from '../hooks/useWindowDimensions';

import './BackToTop.scss';

function BackToTop() {
    const { height: windowHeight } = useWindowDimensions();
    function shouldIShow(amountScrolled) {
        return amountScrolled > 1000;
    }

    function showComponent(component) {
        component.style.bottom = `${Math.round(windowHeight / 4)}px`;
        component.style.display = shouldIShow(window.scrollY) ? 'flex' : 'none';
    }

    function scrollSmoothly() {
        window.scroll({
            top: 0,
            behavior: 'smooth',
        });
    }

    useEffect(() => {
        let backToTop = document.querySelector('.back-to-top');
        showComponent(backToTop);

        window.addEventListener('scroll', () => {
            showComponent(backToTop);
        });
    });

    return (
        <div className='back-to-top' onClick={scrollSmoothly}>
            <span>&uarr;</span>
        </div>
    );
}

export default BackToTop;
